export const useRTL = (locale: string): boolean => {
  const isRTL = () => {
    switch (locale) {
      case 'ar':
        return true;
      case 'he':
        return true;
      default:
        return false;
    }
  };

  return isRTL();
};
